import React from "react";

export default function InputWithIcon({value='', placeholder = '', onChange, disabled, inputStyle, iconClassName, onClickIcon}) {

    return <div className="icon-input-container" readOnly={disabled}>
        <input type="text" className="form-control" value={value} onChange={onChange} readOnly={disabled} style={inputStyle} placeholder={placeholder}/>
        <i className={iconClassName} onClick={onClickIcon}/>
    </div>
}
